import { render, staticRenderFns } from "./TaxAddForm.vue?vue&type=template&id=2ba5e38a&lang=html&"
import script from "./TaxAddForm.vue?vue&type=script&lang=js&"
export * from "./TaxAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports